import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getDatabase, ref, get } from 'firebase/database'; 
import { database } from '../../firebase';  
import Style from '../assets/css/drawings.module.css';

const ImageDetail = () => {
    const { imageId } = useParams();
    const [image, setImage] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchImageDetails = async () => {
            try {
                const imageRef = ref(database, `shared/images/${imageId}`);  
                const imageSnapshot = await get(imageRef);
                const imageData = imageSnapshot.val();
                if (imageData) {
                    setImage(imageData);
                } else {
                    console.log('Image not found');
                }
            } catch (error) {
                console.error('Error fetching image details:', error);
            }
        };

        fetchImageDetails();
    }, [imageId]);

    if (!image) {
        return <p>Loading...</p>;
    }

    return (
        <div className={Style.imageDetailContainer}>
            <button onClick={() => navigate(-1)} className={Style.backButton}>
                Regresar
            </button>
            <h1 className={Style.imageDetailTitle}>{image.imageName}</h1>
            <img src={image.imageURL} alt={image.imageName} className={Style.centeredImage} />
            <p className={Style.imageStory}>{image.storyText}</p>
        </div>
    );
}

export default ImageDetail;
